import { Toaster } from "react-hot-toast";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import AboutPage from "./pages/AboutPage/AboutPage";
import CompanyPage from "./pages/CompanyPage/CompanyPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import LogoutPage from "./pages/LogoutPage/LogoutPage";
import RegisterPage from "./pages/RegisterPage/RegisterPage";
import SplashPage from "./pages/SplashPage/SplashPage";
import VerifyEmailPage from "./pages/VerifyEmailPage/VerifyEmailPage";

import "./App.scss";
import OnboardingRoutes from "./OnboardingRoutes";

function App() {
  return (
    <Router>
      <Toaster />
      <Routes>
        <Route path="/" element={<SplashPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/onboard/*" element={<OnboardingRoutes />} />
        <Route path="/company/:handle" element={<CompanyPage />} />
        <Route path="*" element={<AppRoutes />} />
      </Routes>
    </Router>
  );
}

export default App;
